import {JhiAlertComponent} from "../../shared";

export class EntityVerification {
    // noinspection JSUnusedGlobalSymbols
    constructor(
        public entityId?: number,
        public applicationName?: String,
        public entityName?: String,
        public verificationOk?: boolean,
        public message?: String,
        public params?: any[],
        public translatedMessage?: String
    ) {
    }


    public static construitCleMessage(entity: EntityVerification): string {
        return JhiAlertComponent.construitCleMessage(
            entity.message,
            entity.entityName,
            entity.applicationName
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/entity-verification.model.ts